import React, { PureComponent } from 'react'

import './ScrollPicker.css'

const SELECTED_ITEM_CLASSNAME = 'cm-scrollpicker--item__selected'

const range = (from, to) => {
  return Array.from({ length: to - from + 1 }, (_, k) => from + k)
}
const spacers = outer => {
  return Array.from(outer.querySelectorAll('.cm-scrollpicker--spacer'))
}
const items = outer => {
  return Array.from(outer.querySelectorAll('.cm-scrollpicker--item'))
}
const selectedItem = outer => {
  return outer.querySelector('.cm-scrollpicker--item__selected')
}
const itemForValue = (outer, value) => {
  return outer.querySelector(`.cm-scrollpicker--item[data-value="${value}"]`)
}
const isItem = target => {
  return target.classList.contains('cm-scrollpicker--item')
}
const setSmooth = outer => {
  outer.classList.add('cm-scrollpicker--outer__smoothed')
}
const unsetSmooth = outer => {
  if (outer.classList.contains('cm-scrollpicker--outer__smoothed')) {
    outer.classList.remove('cm-scrollpicker--outer__smoothed')
  }
}
const outerWidth = outer => {
  return outer.offsetWidth
}
const spacerWidth = (outerWidth, itemWidth) => {
  return outerWidth / 2 - itemWidth / 2
}

export default class ScrollPicker extends PureComponent {
  autoPositioned = false

  scrolled = e => {
    e.preventDefault()
    e.stopPropagation()

    if (this.autoPositioned) {
      this.autoSelected = true
    }

    const { onChanged } = this.props
    const target = e.target
    const scroll = target.scrollLeft
    const median = scroll + outerWidth(this.outer) / 2
    const selected = items(this.outer).reduce(
      (acc, item) => (item.offsetLeft > median ? acc : item)
    )

    const previous = selectedItem(this.outer)

    if (
      previous !== null &&
      previous.dataset.value !== selected.dataset.value
    ) {
      previous.classList.remove(SELECTED_ITEM_CLASSNAME)
    }

    if (
      (this.autoSelected || this.autoPositioned) &&
      !selected.classList.contains(SELECTED_ITEM_CLASSNAME)
    ) {
      selected.classList.add(SELECTED_ITEM_CLASSNAME)
      onChanged(selected.dataset.value)
    }

    setTimeout(() => {
      if (scroll === target.scrollLeft) {
        this.moveTo(selected.offsetLeft)
      }
    }, 60)
  }

  computePosition = x => {
    const { itemWidth } = this.props
    return x - outerWidth(this.outer) / 2 + itemWidth / 2
  }

  moveTo = x => {
    this.outer.scrollLeft = this.computePosition(x)
  }

  touched = e => {
    const { onChanged } = this.props
    const target = e.target
    if (isItem(target)) {
      const currentPosition = target.offsetLeft
      const targetPosition = parseInt(this.computePosition(currentPosition), 10)
      const scrollPosition = this.outer.scrollLeft
      if (scrollPosition === targetPosition) {
        target.classList.add(SELECTED_ITEM_CLASSNAME)
        onChanged(target.dataset.value)
      } else {
        this.moveTo(currentPosition)
      }
    }
  }

  resized = e => {
    this.resizeSpacers()
    const selectedItemElement = selectedItem(this.outer)
    if (selectedItemElement !== null) {
      this.moveTo(selectedItemElement.offsetLeft)
    }
  }

  resizeSpacers() {
    const { itemWidth } = this.props
    spacers(this.outer).forEach(spacer => {
      spacer.style.width = `${spacerWidth(outerWidth(this.outer), itemWidth)}px`
    })
  }

  setStartingPosition() {
    unsetSmooth(this.outer)

    const { defaultValue } = this.props

    const defaultItem = itemForValue(
      this.outer,
      defaultValue !== undefined ? defaultValue : 1
    )

    this.moveTo(defaultItem.offsetLeft)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setSmooth(this.outer)
        this.autoPositioned = true
      })
    })
  }

  componentWillMount() {
    const { autoSelected, transform } = this.props
    this.autoSelected = autoSelected === true || false
    this.transform = transform === undefined ? x => x : transform
  }

  componentDidMount() {
    this.resizeSpacers()
    this.setStartingPosition()
    window.addEventListener('resize', this.resized)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resized)
  }

  componentDidUpdate() {
    const { autoSelected } = this.props

    this.autoSelected = autoSelected === true || false
    this.autoPositioned = false

    this.resizeSpacers()
    requestAnimationFrame(() => {
      this.setStartingPosition()
    })
  }

  render() {
    const { from, to, itemWidth } = this.props
    return (
      <div
        className="cm-scrollpicker--outer"
        onScroll={this.scrolled}
        ref={outer => {
          this.outer = outer
        }}
      >
        <div className="cm-scrollpicker--inner" onClick={this.touched}>
          <span className="cm-scrollpicker--spacer" />
          {range(from, to).map(x => (
            <span
              key={x}
              data-value={x}
              className="cm-scrollpicker--item"
              style={{ width: itemWidth + 'px' }}
            >
              {this.transform(x)}
            </span>
          ))}
          <span className="cm-scrollpicker--spacer" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ScrollPicker.js